import { i18n } from '@fs/zion-locale'

export default {
  changeHistoryDuplicate: i18n.t(
    'Internal.changeHistoryDuplicate',
    'Reprocessing has already been requested for this folder.'
  ),
  changeHistoryInfo: i18n.t('Internal.changeHistoryInfo', 'Please wait up to 60 minutes for reprocessing to complete'),
  changeHistoryReprocessed: i18n.t('Internal.changeHistoryReprocessed', 'Status: Reprocessed'),
  changeHistoryRequested: i18n.t('Internal.changeHistoryRequested', 'Status: Requested'),
  changeHistoryTitle: i18n.t('Internal.changeHistoryTitle', 'Change History'),
  crop: () => i18n.t('Internal.Crop', 'Crop'),
  deskew: () => i18n.t('Internal.Deskew', 'Deskew'),
  reprocessFolder: () => i18n.t('Internal.ReprocessFolder', 'Reprocess Folder'),
  reprocessOperations: () => i18n.t('Internal.ReprocessOperations', 'Image operations to apply'),
  requestSubmitted: () => i18n.t('Internal.RequestSubmitted', 'Request submitted'),
  sharpen: () => i18n.t('Internal.Sharpen', 'Sharpen'),
}
